export default [
    {
        name: 'Created Date',
        value: 't_created',
        datetime: true,
        utc: true
    },
    {
        name: 'MAWB',
        value: 's_mawb'
    },
    {
        name: 'HAWB',
        value: 's_hawb'
    },
    {
        name: 'Type',
        value: 's_type'
    },
    {
        name: 'Check #',
        value: 's_payment_reference'
    },
    {
        name: 'Amount',
        value: 'f_amount',
        money: true
    },
    {
        name: 'Processed by',
        value: 's_created_by',
        email: true
    },
];